import React, { useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";

import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";

import imagenProvincia from '../assets/img/provincia2.jpg';
import IRM_2 from '../assets/software/IRM_2.6.bat';
import whatsapp from '../assets/img/whatsapp.svg';

const videoArrProvincia = "https://www.youtube.com/embed/3vgZwCx4XXU?si=DEii-X6CPYh8XLga";

const Provincia = () => {
  const { accounts } = useMsal();
  
  const hasMsalAccount = accounts && accounts.length > 0;
  const hasLocalSession = Object.keys(localStorage).some(key => key.includes('msal'));
  const isAuthenticated = hasMsalAccount || hasLocalSession;

  let usuario = null;
  if (hasMsalAccount) {
    usuario = {
        nombre: accounts[0].name,
        correo: accounts[0].username
    };
  } else if (hasLocalSession) {
    usuario = {
        nombre: "Docente Ministerio",
        correo: "institucional@me.cba.gov.ar"
    };
  }
  
  const [data, setData] = useState({ status: "", device: null }); 
  const [isValid, setIsValid] = useState(false);

  const [msn, setMSN] = useState('');
  const [idEquipo, setID] = useState('');

  const [ct, setCT] = useState('');
  const [uc, setUC] = useState('');

  const [solucion, setSolucion] = useState({ status: "", unlock_code: "" });

  let contSelEquipo = document.getElementById('contSelEquipo');
  let contCT = document.getElementById('contCT');
  let contSolucion = document.getElementById('contSolucion');
  let input_msn = document.getElementById('input_msn');

  const selMSN = () => {
    contSelEquipo && contSelEquipo.classList.add('d-none');
    contCT && contCT.classList.add('d-none');
    contSolucion && contSolucion.classList.add('d-none');

     setMSN(''); 
     setData({ status: "", device: null });  
     setID('');
     setCT('');
     setUC('');
     setSolucion({ status: "", unlock_code: "" });
  };

  const cambioMSN = (e) => {
     contSelEquipo && contSelEquipo.classList.add('d-none');
     contCT && contCT.classList.add('d-none');
     contSolucion && contSolucion.classList.add('d-none');

     setData({ status: "", device: null });  
     setMSN(e.target.value); 
     setIsValid(e.target.value.length >= 8);
  };

  const [sesion, setSesion] = useState({
    id: '',
    correo: '',
    usuario: '',
    msn: '',
    bios_number: '',
    ct_uc: '',
    solucion: '',
    descarga: '',
    wsp: ''
  });

  const [idSesion, setIdSesion] = useState();

  const iniciarSesion = async () => {
    if (!usuario) return false;
    const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          msn: msn,
          usuario: usuario.nombre,
          correo: usuario.correo
        })
    };

    try {
        const response = await fetch('https://pjb.edu.ar/api/ctrdesbloqueos/pixart', options);
        if (!response.ok) throw new Error(`Error: ${response.status}`);
        const result = await response.json();
        setIdSesion(result.data.id);
        return true;
    } catch (err) {
        console.error('Error al iniciar sesión interna:', err);
        return false;
    }
  };

  const modificarSesion = async (nuevosDatos) => {
    const updatedSesion = { ...sesion, ...nuevosDatos };
    const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedSesion)
    };

    try {
        const response = await fetch('https://pjb.edu.ar/api/ctrdesbloqueos/pixart?id=' + idSesion, options);
        await response.json();
        setSesion(updatedSesion);
        return true;
    } catch (err) {
        console.error("Error al modificar sesión interna:", err);
    }
  };

  const buscarEquipo = async () => {
      await iniciarSesion();
      
      let contWsp = document.getElementById('contWsp');
      contWsp && contWsp.classList.remove('d-none');

      contSelEquipo && contSelEquipo.classList.remove('d-none');
      contCT && contCT.classList.add('d-none');
      contSolucion && contSolucion.classList.add('d-none');

      setData({ status: "", device: null });
      setID('');
      setCT('');
      setUC('');
      setSolucion({ status: "", unlock_code: "" });

      try {
          const response = await fetch('https://pjb.edu.ar/api/api-desbloqueos/?msn=' + msn);
          const resJson = await response.json();

          setData(resJson);

          if (resJson.status === "error") {
              contSelEquipo && contSelEquipo.classList.add('d-none');
              input_msn && input_msn.classList.add('is-invalid');
          } else {
              input_msn && input_msn.classList.remove('is-invalid');
              input_msn && input_msn.classList.add('is-valid');
             
              contSelEquipo && contSelEquipo.scrollIntoView({ behavior: 'smooth' });

              if (resJson.device) {
                  contSelEquipo && contSelEquipo.classList.add('d-none');
                  selEquipo(resJson.device.id);
              }
          }
      } catch (error) {
          console.error('Error fetching data for Equipos provincia:', error);
      }
  };

  const selEquipo = (id_equipo) => {
     contCT && contCT.classList.remove('d-none');
     contCT && contCT.scrollIntoView({ behavior: 'smooth' });
     setID(id_equipo);
  }; 

  const cambioCT = (e) => setCT(e.target.value);
  const cambioUC = (e) => setUC(e.target.value);

  const generarCodigo = async () => {
    if (!usuario) return;
    modificarSesion({
        id: idSesion,
        usuario: usuario.nombre,
        correo: usuario.correo,
        msn: msn,
        ct_uc: ct + "-" + uc,
    });

    setSolucion({ status: "", unlock_code: "" });
    cargarSolucion();

    try {
        const response = await fetch(`https://pjb.edu.ar/api/api-desbloqueos/?id=${idEquipo}&ct=${ct}&uc=${uc}`);
        const resJson = await response.json();
        
        setSolucion(resJson);  

        if (resJson.status === "success") {
            modificarSesion({
              id: idSesion,
              usuario: usuario.nombre,
              msn: msn,
              ct_uc: ct + "-" + uc,
              solucion: resJson.unlock_code 
            });
        }
    } catch (err) {
        console.error("Error al generar código:", err);
    }
  };

  const cargarSolucion = () => {
    contSolucion && contSolucion.classList.remove('d-none');
    contSolucion && contSolucion.scrollIntoView({ behavior: 'smooth' });
  };

  const controlDescarga = () => {
    if (!usuario) return;
    modificarSesion({
      id: idSesion,
      usuario: usuario.nombre,
      correo: usuario.correo,
      msn: msn,
      ct_uc: ct + "-" + uc,
      descarga: 'OK'
    });
  };

  const controlWsp = () => {
    if (!usuario) return;
    modificarSesion({
      id: idSesion,
      usuario: usuario.nombre,
      correo: usuario.correo,
      msn: msn,
      ct_uc: ct + "-" + uc,
      wsp: 'OK'
    });
  };

  if (isAuthenticated) {
    return (
      <div className="container contOption">
            <div className="card mb-3">
              <div className="card-header">Usuario</div>
              <div className="card-body">
                <h5 className="card-title">Hola, {usuario?.nombre}</h5>
                <p className="card-text">Sistema de desbloqueo de equipos entregados por la provincia de Córdoba</p>
                <SignOutButton />
              </div>
            </div>
     
            <div className="card">
              <div className="card-body">
              <h2 className="card-title">Provincia</h2> 
                <div className='row mt-3'>
                  <div className='col-1 mt-2'>
                      <span className="material-symbols-outlined">error</span>
                  </div>
                  <div className='col-10'>
                    <p className='text-warning'> IMPORTANTE! Para realizar el desbloqueo debés prender el equipo como se muestra en la imagen, ya que utilizaremos los numeros que se observan en la pantalla</p>
                  </div>
                </div>
              
                <div className="row"> 
                  <div className="col-12 d-flex justify-content-center">
                    <img 
                      src={imagenProvincia}
                      className="rounded mx-auto d-block img-fluid" 
                      width="560" 
                      height="315" 
                      alt="fotografia real de netbook bloqueada"
                    />
                  </div>
                </div>
              </div>
          </div>

          <div className="card mb-4 mt-4" id="contMSN">
              <div className="card-body">
                    <div className='row mt-2 mb-2'>
                          <div className='col-1'>
                              <span className="material-symbols-outlined">error</span>
                          </div>
                          <div className='col-10'>
                            <p className='text-dark'>Debés ingresar el numero "Machine Serial Number (msn)" de tu netbook.</p>
                          </div>
                    </div>

                    <div className='row'>                
                        <div className="col-12 col-md-10 mt-3">
                          <div className="input-group">
                              <span className="input-group-text" id="inputGroup-sizing-default">msn</span>
                              <input 
                                  type="text" 
                                  id="input_msn" 
                                  value={msn}
                                  onChange={cambioMSN} 
                                  minLength={8}
                                  className="form-control" 
                                  aria-label="Sizing example input" 
                                  aria-describedby="inputGroup-sizing-default"
                                />
                              <div className="invalid-feedback" id="mensajeError"></div>
                          </div>
                      </div>
                      <div className='col-12 col-md-10 d-flex justify-content-end'>
                          <p className={msn.length < 8 ? 'text-warning mx-2' : 'text-success mx-2'} >Caract.Min (8): {msn.length}</p>
                      </div>
                      <div className='col-12 d-flex justify-content-end'>
                          <button type="submit" 
                              className="btn btn-outline-secondary mt-3 mx-2" 
                              onClick={buscarEquipo}
                              disabled={!isValid}
                              >
                              Continuar
                          </button>
                      </div>
                    </div>
                  </div>
        </div>

      <div className="card mb-4 mt-4 d-none" id="contSelEquipo">
              <div className="card-body">
                    <div className='row mt-2 mb-2'>
                          <div className='col-1'>
                              <span className="material-symbols-outlined">error</span>
                          </div>
                          <div className='col-10'>
                            <p className='text-dark'>Para continuar debés seleccionar el recuadro que corresponde a tu equipo.</p>
                          </div>
                    </div>

                    <div className='row'>
                    {data.status !== "" ? (
                          <div>
                            {data.status === "success" && data.device && (
                              <div className="list-group">
                                <a className="list-group-item list-group-item-action" key={data.device.id} onClick={() => selEquipo(data.device.id)}>
                                    <p><strong>{data.device.msn}</strong></p>
                                    <p>BIOS Number: {data.device.bios_number}</p>
                                </a> 
                              </div>
                            )}
                          </div>
                        ):(
                          <div className='col-12 text-center'>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <br/>
                            <p>Buscando</p>
                          </div>  
                        )}
                    </div>
              </div>
      </div>
                      
      <div className="card mb-4 mt-4 d-none" id="contCT">
              <div className="card-body">
                      <div className='row mt-2 mb-2'>
                          <div className='col-1'>
                              <span className="material-symbols-outlined">error</span>
                          </div>
                          <div className='col-10'>
                            <p className='text-dark'>Ingresá los numeros ct y uc que aparecen en la pantalla de su computadora para generar código de desbloqueo.</p>
                          </div>
                      </div>

                    <div className='row'>
                          <div className="input-group mt-3">
                                <span className="input-group-text" id="inputGroup-sizing-default">CT</span>
                                <input 
                                    type="text" 
                                    value={ct}
                                    onChange={cambioCT}
                                    className="form-control"  
                                    required
                                />
                          </div> 
                          <div className="input-group mb-2 mt-3">
                                <span className="input-group-text" id="inputGroup-sizing-default">UC</span>
                                <input 
                                    type="text" 
                                    value={uc}
                                    onChange={cambioUC}
                                    className="form-control"  
                                    required
                                />
                          </div> 
                    </div>
                    <div className='row'>
                        <div className='col-12 d-flex justify-content-end'>
                              <button type="submit" 
                                  className="btn btn-outline-secondary mt-3 mx-2" 
                                  onClick={generarCodigo}>
                                  Continuar
                              </button>
                          </div>
                    </div>
              </div>              
      </div>

      <div className="card mb-4 mt-4 d-none" id="contSolucion">
              <div className="card-body">
                      <div className='row mt-2 mb-2'>
                          <div className='col-10'>
                            <h4 className='text-dark'>Solución</h4>
                          </div>
                      </div>

                          {solucion.status !== "" ? (
                              <div className='row'>
                                  {solucion.status === "success" ? (
                                    <>
                                      <div className='col-12'>
                                        <div className='row'>
                                          <div className='col-1'>
                                              <span className="material-symbols-outlined">counter_1</span>
                                          </div>
                                          <div className='col-10'><p>Debés ingresar el siguiente código en la netbook a desbloquear</p></div>
                                        </div>
                                      </div>
                                      <div className='col-12 col-md-9 text-center'>
                                          <h1 className='text-success'>{solucion.unlock_code}</h1>
                                      </div>
                                    </>
                                  ) : (
                                    <div className='col-12'>
                                      <p className="text-danger">Error al calcular el código. Por favor verifique los datos ingresados.</p>
                                    </div>
                                  )}
                                    
                                  <div className='col-12 mt-3'>
                                      <div className='row'>
                                        <div className='col-1'>
                                          <span className="material-symbols-outlined">counter_2</span>
                                        </div>
                                        <div className='col-10'>
                                          <p>Descargá el archivo y seguí las intrucciones del video</p>
                                          </div>
                                      </div>
                                      <div className='row'>
                                        <div className='col-12 col-md-9 d-flex justify-content-center'>
                                            <a 
                                              className="btn btn-outline-success mt-3 mb-3" 
                                              href={IRM_2}
                                              onClick={controlDescarga} 
                                              download="IRM_2.6.bat">
                                                Descarga
                                            </a>
                                        </div>
                                      </div>
                                  </div>   

                                  <div className='col-12 col-md-9 mb-3 mt-3 d-flex justify-content-center'>
                                        <iframe 
                                              width="360" 
                                              height="215" 
                                              src={videoArrProvincia}
                                              title="Video explicativo de como cargar arranques en 2 minutos en la netbook de provinica"                                       
                                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                              >
                                          </iframe>
                                  </div>  
                              
                                  <div className='col-12 d-flex justify-content-end'>
                                        <button type="submit" 
                                            className="btn btn-outline-secondary mt-3 mx-2" 
                                            onClick={selMSN}>
                                            Nueva Busqueda
                                        </button>
                                    </div>
                              </div>
                              ):(
                                <div className='col-12 text-center'>
                                  <div className="spinner-border" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                  </div>
                                  <br/>
                                  <p>Procesando</p>
                                </div>  
                              )}
                      </div>
              </div>

              <div className='col-12 mb-3 mt-2 d-none' id="contWsp">
                              <a                                                                           
                                  href={"https://wa.me/+5493516667355?text=Tengo un incoveniente con el equipo --> " + "MSN:" + msn + " ct:"+ct+ " uc:"+uc} target="_blank" rel="noopener noreferrer"
                                  type="submit"
                                  onClick={controlWsp} 
                                  className="btn btn-outline-success whatsapp" 
                              >
                                <img 
                                          className="p-1" 
                                          src={whatsapp} 
                                          width="40" height="40"
                                          alt="Whatsapp"                                 
                                    />  
                                  Comunicate 
                              </a>
                        </div>
      <div id="bottomOf"></div>   
      </div>
    );
  }

  return (
      <div className="container contOption">
                <div className="row ">
                    <div className="col-12" >
                            <h3 className='text-secondary mb-4'>Inicio de sesión</h3>          
                            <h5 className='text-secondary mb-3'><em>Ingresar con la cuenta institucional provista por el Ministerio de Educación de la Provincia de Córdoba</em></h5> 
                            <h6 className='mb-5'><em>@me.cba.gov.ar</em></h6>
                            {/* Usamos el componente oficial SignInButton embebido en la vista sin popups */}
                            <SignInButton />
                    </div>
                </div>
      </div>
  );
};

export default Provincia;